import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceConfigTermActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Terms/TermsBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceConfigTerm"
				RenderedComponent={this.RenderedComponent}
				context="FinanceConfigTerm"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceConfigTermActivity)
